import React from 'react';
import ReactDOM from 'react-dom';

var WirisEditor = React.createClass({
  editorInstance:null,
  getInitialState: function() {
    return {
      content: this.props.content,
      onChange: this.props.onChange
    }
  },

  componentDidMount: function() {
    var __this = this;
    var editor = window.com.wiris.jsEditor.JsEditor.newInstance({'language': 'en'});
    try {
      editor.insertInto(ReactDOM.findDOMNode(this));
    }
    catch(err) {
      console.log('err', err);
    }
    this.editorInstance = editor;
    var editorModel = editor.getEditorModel();
    editorModel.addEditorListener({
      contentChanged: function(editor) {
        var txt = editor.getMathML();
        __this.state.onChange(txt);
      },
      caretPositionChanged: function(editor) {}
    });
    editor.setMathML(this.state.content);
  },

  componentWillReceiveProps: function(nextProps) {
    // if (nextProps.content !== this.props.content) {
    //   this.editorInstance.setMathML(nextProps.content);
    //   this.setState({
    //     content: nextProps.content || this.props.content,
    //   })
    // }
  },

  render: function() {
    return (
      // <span style={{maxHeight:300}}> </span>
      <div style={{ height: 200}}> </div>
    );
  }
});

export default WirisEditor;


/** WEBPACK FOOTER **
 ** ./src/components/WirisEditor/WirisEditor.js
 **/